module.exports = __webpack_public_path__ + "static/media/appetizer.78ebdc5a.png";